import { EventBus } from 'components/eventBus';
import { TLoggerEvents } from 'components/logger/Logger.events';
import { EPlaybackState, TMediaStream } from 'types/common';

export enum EVideoElementControllerBusEvent {
  NATIVE_EVENT = 'videoElementController.nativeEvent',
  CLICK = 'videoElementController.click',
  FORCE_PLAY_AFTER_PAUSE = 'videoElementController.forcePlayAfterPause',
  VIDEO_START = 'videoElementController.videoStart',
  VIDEO_PAUSE = 'videoElementController.videoPause',
  VIDEO_RESET = 'videoElementController.videoReset',
  PAUSED = 'videoElementController.paused',
  PLAYING = 'videoElementController.playing',
  LOADING = 'videoElementController.loading',
  LOADED = 'videoElementController.loaded',
  UPDATED = 'videoElementController.updated',
  DESTROY = 'videoElementController.destroy',
  STREAM_RESET = 'videoElementController.streamReset',
  CAN_PLAY = 'videoElementController.canPlay',
  REMOVE_MEDIA_STREAM = 'videoElementController.removeMediaStream',
  ERROR = 'videoElementController.error',
  ABORT = 'videoElementController.abort',
  STALLED = 'videoElementController.stalled',
  WAITING = 'videoElementController.waiting',
  UPDATE_PLAYER_RESOLUTION = 'videoElementController.updatePlayerResolution',
  RESET_CHECKING_AUTOPLAY_COUNT = 'videoElementController.resetCheckingAutoplayCount',
  CANCEL_RESET_STREAM = 'videoElementController.cancelResetStream',
  RESTART = 'videoElementController.restart',
  TIME_UPDATE_NATIVE = 'videoElementController.native',
  UPDATE_MEDIA_STREAM = 'videoElementController.updateMediaStream',
  VIDEO_ELEMENT_RECREATED = 'videoElementController.videoElementRecreated',
  VIDEO_PLAYBACK_STATE_CHANGED = 'videoElementController.videoPlaybackStateChanged',
  SET_VOLUME = 'videoElementController.setVolume',
}

type TNativeEventKey = keyof HTMLVideoElementEventMap;

export interface IVideoElementControllerBusEventsMap {
  [EVideoElementControllerBusEvent.NATIVE_EVENT]: {
    eventName: TNativeEventKey;
    event: HTMLVideoElementEventMap[TNativeEventKey];
  };
  [EVideoElementControllerBusEvent.CLICK]: { originalEvent: Event };
  [EVideoElementControllerBusEvent.FORCE_PLAY_AFTER_PAUSE]: { reason?: string };
  [EVideoElementControllerBusEvent.VIDEO_START]: {};
  [EVideoElementControllerBusEvent.VIDEO_PAUSE]: {};
  [EVideoElementControllerBusEvent.VIDEO_RESET]: {};
  [EVideoElementControllerBusEvent.DESTROY]: {};
  [EVideoElementControllerBusEvent.PLAYING]: { isAutoplay?: boolean };
  [EVideoElementControllerBusEvent.LOADING]: {};
  [EVideoElementControllerBusEvent.LOADED]: {};
  [EVideoElementControllerBusEvent.STREAM_RESET]: {
    reason?: string;
    timeout?: number;
  };
  [EVideoElementControllerBusEvent.CAN_PLAY]: {};
  [EVideoElementControllerBusEvent.PAUSED]: {};
  [EVideoElementControllerBusEvent.REMOVE_MEDIA_STREAM]: {};
  [EVideoElementControllerBusEvent.ERROR]: { originalEvent: Event };
  [EVideoElementControllerBusEvent.ABORT]: {};
  [EVideoElementControllerBusEvent.UPDATE_PLAYER_RESOLUTION]: {
    height: number;
    width: number;
  };
  [EVideoElementControllerBusEvent.RESET_CHECKING_AUTOPLAY_COUNT]: {};
  [EVideoElementControllerBusEvent.CANCEL_RESET_STREAM]: {};
  [EVideoElementControllerBusEvent.RESTART]: {};
  [EVideoElementControllerBusEvent.UPDATED]: {};
  [EVideoElementControllerBusEvent.STALLED]: {};
  [EVideoElementControllerBusEvent.WAITING]: {};
  [EVideoElementControllerBusEvent.UPDATE_MEDIA_STREAM]: TMediaStream;
  [EVideoElementControllerBusEvent.VIDEO_ELEMENT_RECREATED]: { videoElement: HTMLVideoElement };
  [EVideoElementControllerBusEvent.TIME_UPDATE_NATIVE]: {
    originalEvent: Event;
  };
  [EVideoElementControllerBusEvent.VIDEO_PLAYBACK_STATE_CHANGED]: {
    prevState: EPlaybackState;
    nextState: EPlaybackState;
  };
  [EVideoElementControllerBusEvent.SET_VOLUME]: {
    volume: number;
  };
}

export type TVideoControllerEventBus = EventBus<
  IVideoElementControllerBusEventsMap & TLoggerEvents
>;
